import { useCallback, useLayoutEffect, useState } from 'react';
import { useViewport } from '@lamimed/pantheon';
import Image from 'next/legacy/image';

import { useSmallMobileScreen } from 'hooks/useSmallMobileScreen';

import { capsulaUrl } from 'utils/links';

import { Modal } from 'partials/Modal';

import * as S from './styles';

import mainHeroImg from '/public/images/main-hero-img.png';

export const Hero: React.FC = () => {
  const { greaterThan, lessThan } = useViewport();
  const { isOnSmallMobileScreen } = useSmallMobileScreen();
  const [screenHeight, setScreenHeight] = useState<number>();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useLayoutEffect(() => {
    setScreenHeight(window?.innerHeight);
  }, []);

  const resizeImage = useCallback(() => {
    const imageSizes = {
      isSmallMobile: { width: 185, height: 180 },
      isTabletOrSmaller: { width: 253, height: 270 },
      isGreaterThanTablet: { width: 340, height: 356 },
    };

    if (isOnSmallMobileScreen) {
      return imageSizes['isSmallMobile'];
    }

    if (greaterThan('tablet')) {
      return imageSizes['isGreaterThanTablet'];
    }

    return imageSizes['isTabletOrSmaller'];
  }, [greaterThan, isOnSmallMobileScreen]);

  return (
    <>
      <S.HeroBackground deviceHeight={screenHeight}>
        <S.Wrapper>
          <S.MainCallToAction as="header">
            <S.HeroImageWrapper>
              <Image
                src={mainHeroImg}
                alt="Hero"
                width={resizeImage().width}
                height={resizeImage().height}
                layout={greaterThan('tablet') ? 'responsive' : 'intrinsic'}
                objectFit="contain"
                quality={100}
                placeholder="blur"
              />
            </S.HeroImageWrapper>

            <S.ContentWrapper>
              <S.TextWrapper>
                <S.Title color="text__light" textAlign="left" forwardedAs="h1">
                  La tua guida verso il giusto percorso di cura
                </S.Title>

                <S.Description textAlign="left" color="text__light">
                  Lami è la piattaforma di primary care che aiuta le persone a
                  prendere le giuste decisioni per la loro salute, facilitando
                  l’interpretazione dei sintomi e l’interazione con il medico.
                </S.Description>
              </S.TextWrapper>

              <S.Button
                extended={lessThan('tablet')}
                shrinked={greaterThan('tablet')}
                size="large"
                color="secondary"
                onClick={() => setIsModalOpen(true)}
              >
                Area associati
              </S.Button>
            </S.ContentWrapper>
          </S.MainCallToAction>
        </S.Wrapper>
      </S.HeroBackground>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Lami ora è Capsula"
        body="Crea un account su Capsula e continua a utilizzare i servizi."
        ctaLabel="Accedi ora"
        ctaHref={capsulaUrl}
      />
    </>
  );
};
